import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Bugcrowd extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M15.414,15.1A4.718,4.718,0,0,0,15.3,11.98a2.656,2.656,0,0,0-.9-1.137,2.334,2.334,0,0,0-1.344-.408,2.534,2.534,0,0,0-.969.188,2.359,2.359,0,0,0-.83.6,2.864,2.864,0,0,0-.579,1.025,4.8,4.8,0,0,0-.216,1.493,4.52,4.52,0,0,0,.159,1.186,3.362,3.362,0,0,0,.483,1.032,2.4,2.4,0,0,0,.8.729,2.323,2.323,0,0,0,1.127.273,2.359,2.359,0,0,0,1-.216,2.42,2.42,0,0,0,.824-.629A3.01,3.01,0,0,0,15.414,15.1Zm2.8-1.422a6.928,6.928,0,0,1-.354,2.255,5.133,5.133,0,0,1-.99,1.726,4.312,4.312,0,0,1-1.5,1.1,4.649,4.649,0,0,1-1.895.39A4.141,4.141,0,0,1,12.331,19a3.675,3.675,0,0,1-.868-.365,3.792,3.792,0,0,1-.6-.438,3.039,3.039,0,0,1-.466-.52h-.041l.021.2c.012.168.018.335.02.5V18.9H7.961V7.011a.47.47,0,0,0-.114-.342.456.456,0,0,0-.33-.109H6.706V4.345H9.158a1.41,1.41,0,0,1,1.048.335,1.45,1.45,0,0,1,.33,1.059V8.774c0,.26-.01.472-.02.633l-.02.249h.04a1.827,1.827,0,0,1,.112-.15A3,3,0,0,1,11,9.144a3.467,3.467,0,0,1,.6-.431,3.9,3.9,0,0,1,.875-.362,4.345,4.345,0,0,1,1.162-.15,4.425,4.425,0,0,1,1.895.4,4.119,4.119,0,0,1,1.445,1.121h0a5.133,5.133,0,0,1,.918,1.733,7.388,7.388,0,0,1,.322,2.221M24,12,18,1.274H6L0,12,6,22.726H18Z" />
      </svg>
    );
  }
}

export default Bugcrowd;
